const OverlayLoaderBoardReadyButtons = ({title, onClick, buttonStyle}) => {
  return (
    <div className="overlay-loader_button-container">
      <button
        type="button"
        className={`button overlay-loader_box-content_button overlay-loader_box-content_button--${buttonStyle}`}
        onClick={onClick}>
        {title}
      </button>
    </div>
  );
};

OverlayLoaderBoardReadyButtons.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  buttonStyle: PropTypes.string
};

OverlayLoaderBoardReadyButtons.defaultProps = {
  onClick() {},
  title: 'ready - view board    ➞',
  buttonStyle: 'plain'
};

export default OverlayLoaderBoardReadyButtons;
